import gql from 'graphql-tag'
import { AttackStatus } from '../attack-status'
import { ServerEnvironment } from '../server-environment'
import { Role } from '@contrast-security-inc/base-types'
import { SourceName } from '../source-names'
import { AgentLanguageKey } from '../agent-language/agent-language'

export type UserInputType =
  | 'PARAMETER_NAME'
  | 'PARAMETER_VALUE'
  | 'QUERYSTRING'
  | 'BODY'
  | 'COOKIE_NAME'
  | 'COOKIE_VALUE'
  | 'URI'
  | 'SOCKET'
  | 'JSON_VALUE'
  | 'JSON_ARRAYED_VALUE'
  | 'MULTIPART_CONTENT_TYPE'
  | 'MULTIPART_VALUE'
  | 'MULTIPART_FIELD_NAME'
  | 'MULTIPART_NAME'
  | 'XML_VALUE'
  | 'DWR_VALUE'
  | 'UNKNOWN'
  | 'METHOD'
  | 'REQUEST'
  | 'HEADER'

export enum AttackType {
  AUTOMATED = 'AUTOMATED',
  MANUAL = 'MANUAL'
}

export interface AttackEvent {
  readonly id: string
  readonly ruleUuid: string
  readonly result: AttackStatus
  readonly sourceIP: string
  readonly received: string
  readonly displayName: string
  readonly url: string
  readonly attackType: AttackType
  readonly attackers: string[]
  readonly type: string
  readonly sourceName?: SourceName
  readonly tags: string[]
  readonly details?: {
    readonly findings?: string
    readonly query?: string
    readonly command?: string
    readonly entryName?: string
    readonly path?: string
  }
  readonly userInput?: {
    readonly value: string
    readonly name?: string
    readonly type: UserInputType
    readonly truncatedValue: boolean
  }
  readonly application: {
    readonly id: string
    readonly name: string
    readonly url: string
    readonly role?: Role
    readonly language: AgentLanguageKey
  }
  readonly server: {
    readonly id: string
    readonly name: string
    readonly environment: ServerEnvironment
  }
  readonly hasExclusion: boolean
}

export const attackEventFragment = gql`
  fragment AttackEvent on AttackEvent {
    id
    ruleUuid
    result
    sourceIP
    received
    displayName
    type
    url
    attackType
    attackers
    sourceName {
      id
      name
      start
      expiration
      expired
      cidrBlocks
      modified
    }
    tags
    hasExclusion
    details {
      findings
      query
      command
      entryName
      path
      start
      end
    }
    userInput {
      value
      name
      type
      truncatedValue
    }
    application {
      id
      name
      role
      language
    }
    server {
      id
      name
      environment
    }
  }
`
